import { toast } from "react-toastify";

function handleSuccessToast({ message }: { message: string }) {
  return toast.success(message);
}

function handleNetworkError({
  error,
}: {
  error: { response: any; message: string } extends Error ? any : any;
}) {
  const message = error?.response.data.message || "Internal Server Error!";
  handleErrorToast({ message });
}

function handleErrorToast({ message }: { message: string }) {
  return toast.error(message);
}

export { handleErrorToast, handleNetworkError, handleSuccessToast };
